/**
 * leatherTooling — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const leatherToolingPack: ToilePack = {
    slug: 'leather-tooling',
    category: 'leather',
    name: 'Leather tooling patterns',
    tagline: tagline('patterns', 'motifs', 'treatments'),
    chips: chips('motifs', 'treatments'),
    ratio: SQUARE,
    readings: [
        {key: 'sheridan', label: 'Sheridan floral', subject: 'scrolling stems, wild roses and acanthus leaves'},
        {key: 'oak', label: 'Oak & acorn', subject: 'oak leaves and acorns on a curving branch'},
        {key: 'celtic', label: 'Celtic knot', subject: 'over-under interlaced woven bands'},
    ],
    styles: [
        {key: 'template', label: 'Pattern template', style: 'printable template, cut lines and spurs marked', palette: 'black line on pure white', framing: 'flat, centered, no leather'},
        {key: 'tooled', label: 'Tooled leather', style: 'swivel-knife cut and beveled into the hide', palette: 'warm burnished vegetable-tan', framing: 'raking side light, relief reads'},
        {key: 'borderset', label: 'Border & corner', style: 'border strip, corner unit and filler motif', palette: 'black line on pure white', framing: 'elements laid out separately'},
    ],
    directions: ['a western cactus instead', 'sized for a belt strip', 'simpler, fewer scrolls'],
}
